export default function XIF({condition, children}) {
  return condition ? children : <></>
}